import { DestinationPage, Page } from '@components/ssap/SsapTypes';

interface CurrentAndMaxAchievedPages {
    currentPage: Page,
    maxAchievedPage: Page
}

export const getCurrentAndMaxAchievedPages = (
    destinationPage: DestinationPage,
    page: Page,
    maxAchievedPage: Page,
    isDataPotentiallyInconsistent: boolean,
    adjustedFlow: { isActive: boolean }[] = []
): CurrentAndMaxAchievedPages => {
    let currentPage: Page;

    switch(destinationPage) {
        case 'increase':
            currentPage = adjustedFlow.findIndex((p, idx) => p.isActive && idx > page); break;
        case 'decrease':
            currentPage = adjustedFlow.reduce((closestWithLessIndexPage, p, idx) => {
                return p.isActive && idx < page ? idx : closestWithLessIndexPage;
            }, Infinity); break;
        default:
            currentPage = destinationPage; break;
    }

    return {
        currentPage,
        maxAchievedPage: (maxAchievedPage < currentPage || isDataPotentiallyInconsistent)
            ? currentPage
            : maxAchievedPage
    };
};